import React from 'react'; 
import WithConsumer from '../../context/WithConsumer';
import InfoIntro from './InfoIntro';
import InfoAbout from './InfoAbout';
import InfoServices from './InfoServices';
import InfoSectors from './InfoSectors';
import InfoImage from './InfoImage';
import InfoAwards from './InfoAwards';
import Footer from './../global/Footer';

const Info = ({ context }) => {
		 
    const posts = () => context.posts;
    const post = posts()[0];
         
    if (post) {
				
		return (					
			<div className="c-info">
				<InfoIntro post={post}></InfoIntro>
				<InfoAbout post={post}></InfoAbout>
				<InfoServices post={post}></InfoServices>
				<InfoSectors post={post}></InfoSectors>
				<InfoImage post={post}></InfoImage>
				<InfoAwards post={post}></InfoAwards>
				<Footer post={post}></Footer>
			</div>				
		)
			
	} else {
		
		return null;
	
	}
};
export default WithConsumer(Info);